import styled from '@emotion/styled';
import { FormLabel } from 'components';
import { Flex } from 'components/layout/Flex';

export const RemainingCharWrapper = styled.span`
  display: flex;
  margin-top: 6px;
`;

export const FailureDescriptionWrapper = styled.div`
  flex-grow: 1;
  margin-left: 32px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  font-family: ${({ theme }) => theme.fonts.default};
  resize: none;
  ${({ hasError, theme }) =>
    hasError &&
    `
    background-color: ${theme.colors.backgroundDanger};
    border-color: ${theme.colors.borderDanger};
  `}
`;

export const SelectField = styled(Flex)`
  flex-direction: column;
  min-width: 180px;
`;

export const ReviewRequestedLabel = styled(FormLabel)`
  margin: 20px 0 8px;
  color: ${({ theme }) => theme.colors.danger};
`;

export const CancelReviewAction = styled.a`
  margin-top: 6px;
  color: ${({ theme }) => theme.colors.danger};
`;
export const ReviewCounter = styled.span`
  margin-top: 6px;
  color: ${({ theme }) => theme.colors.danger};
`;
